var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrutoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "89px",
    height: "85px",
    viewBox: "0 0 89 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 89 47.277344 L 48.148438 47.277344 L 48.148438 46.25 L 89 46.25 Z M 89 47.277344 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 84.007812 56.929688 L 43.15625 56.929688 L 43.15625 55.898438 L 84.007812 55.898438 Z M 84.007812 56.929688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 89 66.574219 L 48.148438 66.574219 L 48.148438 65.542969 L 89 65.542969 Z M 89 66.574219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 87.773438 76.21875 L 46.921875 76.21875 L 46.921875 75.1875 L 87.773438 75.1875 Z M 87.773438 76.21875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 44.472656 67.832031 L 44.472656 62.167969 L 48.226562 62.167969 L 48.546875 62.667969 L 48.546875 67.332031 L 48.226562 67.832031 Z M 44.472656 67.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.757812 62.167969 L 33.757812 67.832031 L 30.003906 67.832031 L 29.6875 67.332031 L 29.6875 62.667969 L 30.003906 62.167969 Z M 33.757812 62.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 44.472656 73.496094 L 44.472656 67.832031 L 48.226562 67.832031 L 48.546875 68.332031 L 48.546875 72.996094 L 48.226562 73.496094 Z M 44.472656 73.496094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.757812 67.832031 L 33.757812 73.496094 L 30.003906 73.496094 L 29.6875 72.996094 L 29.6875 68.332031 L 30.003906 67.832031 Z M 33.757812 67.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 44.472656 79.167969 L 44.472656 73.496094 L 48.226562 73.496094 L 48.546875 74 L 48.546875 78.667969 L 48.226562 79.167969 Z M 44.472656 79.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.757812 73.496094 L 33.757812 79.167969 L 30.003906 79.167969 L 29.6875 78.667969 L 29.6875 74 L 30.003906 73.496094 Z M 33.757812 73.496094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 44.472656 84.832031 L 44.472656 79.167969 L 48.226562 79.167969 L 48.546875 79.667969 L 48.546875 84.332031 L 48.226562 84.832031 Z M 44.472656 84.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.757812 79.167969 L 33.757812 84.832031 L 30.003906 84.832031 L 29.6875 84.332031 L 29.6875 79.667969 L 30.003906 79.167969 Z M 33.757812 79.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 31.394531 62.167969 L 31.394531 56.496094 L 35.148438 56.496094 L 35.46875 56.996094 L 35.46875 61.664062 L 35.148438 62.167969 Z M 31.394531 62.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.6875 56.496094 L 20.6875 62.167969 L 16.933594 62.167969 L 16.613281 61.664062 L 16.613281 56.996094 L 16.933594 56.496094 Z M 20.6875 56.496094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 31.394531 67.832031 L 31.394531 62.167969 L 35.148438 62.167969 L 35.46875 62.667969 L 35.46875 67.332031 L 35.148438 67.832031 Z M 31.394531 67.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.6875 62.167969 L 20.6875 67.832031 L 16.933594 67.832031 L 16.613281 67.332031 L 16.613281 62.667969 L 16.933594 62.167969 Z M 20.6875 62.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 31.394531 73.496094 L 31.394531 67.832031 L 35.148438 67.832031 L 35.46875 68.332031 L 35.46875 72.996094 L 35.148438 73.496094 Z M 31.394531 73.496094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.6875 67.832031 L 20.6875 73.496094 L 16.933594 73.496094 L 16.613281 72.996094 L 16.613281 68.332031 L 16.933594 67.832031 Z M 20.6875 67.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 31.394531 79.167969 L 31.394531 73.496094 L 35.148438 73.496094 L 35.46875 74 L 35.46875 78.667969 L 35.148438 79.167969 Z M 31.394531 79.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.6875 73.496094 L 20.6875 79.167969 L 16.933594 79.167969 L 16.613281 78.667969 L 16.613281 74 L 16.933594 73.496094 Z M 20.6875 73.496094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 31.394531 84.832031 L 31.394531 79.167969 L 35.148438 79.167969 L 35.46875 79.667969 L 35.46875 84.332031 L 35.148438 84.832031 Z M 31.394531 84.832031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.6875 79.167969 L 20.6875 84.832031 L 16.933594 84.832031 L 16.613281 84.332031 L 16.613281 79.667969 L 16.933594 79.167969 Z M 20.6875 79.167969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.25098,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89,
    height: 85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.72549%,12.156863%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 35.46875 84.832031 L 35.46875 62.667969 L 35.148438 62.167969 L 36.34375 62.167969 L 36.34375 84.816406 Z M 35.46875 84.832031 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.372549%,88.627451%,81.568627%)",
      fillOpacity: 1
    },
    d: "M 43.425781 15.785156 L 23.738281 15.785156 C -22.753906 59.773438 9.238281 84.542969 33.582031 84.542969 C 57.925781 84.542969 89.917969 59.773438 43.425781 15.785156 Z M 43.425781 15.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.372549%,88.627451%,81.568627%)",
      fillOpacity: 1
    },
    d: "M 33.582031 84.542969 C 18.746094 84.542969 1.058594 75.339844 0.046875 58.1875 C -0.601562 47.207031 5.582031 32.957031 23.738281 15.785156 L 43.425781 15.785156 C 89.917969 59.777344 57.925781 84.542969 33.582031 84.542969 Z M 33.582031 84.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,91.764706%,85.490196%)",
      fillOpacity: 1
    },
    d: "M 7.960938 59.019531 C 5.375 59.019531 2.707031 58.738281 0.046875 58.1875 C -0.601562 47.207031 5.582031 32.957031 23.738281 15.785156 L 37.699219 15.785156 C 50.964844 43.714844 27.09375 59.019531 7.960938 59.019531 Z M 7.960938 59.019531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,80.784314%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 33.582031 84.542969 C 23.054688 84.542969 11.09375 79.90625 4.667969 71.089844 C 11.183594 75.90625 19.683594 78.402344 27.417969 78.402344 C 50.601562 78.402344 80.734375 55.933594 43.363281 15.785156 L 43.425781 15.785156 C 89.917969 59.777344 57.925781 84.542969 33.582031 84.542969 Z M 33.582031 84.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.372549%,88.627451%,81.568627%)",
      fillOpacity: 1
    },
    d: "M 22.128906 15.785156 L 17.40625 0.375 C 20.855469 -0.878906 23.261719 3.984375 26.453125 3.75 C 29.644531 3.523438 28.871094 1.359375 31.039062 0.808594 C 34.863281 -0.164062 35.796875 4.769531 39.21875 3.996094 C 41.066406 3.574219 42.480469 -0.445312 49.757812 1.066406 L 45.160156 15.785156 Z M 22.128906 15.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 39.164062 19.273438 C 43.527344 26.988281 45.792969 36.597656 45.097656 46.976562 C 45.046875 47.710938 45.761719 48.03125 46.710938 47.652344 C 47.664062 47.277344 48.445312 46.335938 48.457031 45.597656 C 48.617188 35.132812 45.882812 25.578125 41.140625 18.019531 C 40.800781 17.484375 40.09375 17.359375 39.566406 17.699219 C 39.039062 18.035156 38.863281 18.722656 39.171875 19.269531 Z M 39.164062 19.273438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,63.921569%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 45.390625 26.792969 C 42.957031 22.988281 40.15625 20.496094 40.15625 20.496094 C 41.484375 21.421875 43.128906 22.769531 44.398438 24.398438 C 44.398438 24.398438 44.398438 24.402344 44.402344 24.410156 C 44.457031 24.492188 44.511719 24.582031 44.566406 24.667969 C 44.851562 25.367188 45.128906 26.074219 45.390625 26.792969 Z M 45.390625 26.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 37.921875 19.09375 C 42 21.5625 46.410156 24.113281 49.4375 35.785156 C 49.621094 36.5 50.421875 36.554688 51.1875 35.886719 C 51.957031 35.214844 52.4375 34.042969 52.136719 33.367188 C 47.355469 22.441406 43.25 20.253906 39.359375 17.257812 C 38.855469 16.871094 38.152344 16.984375 37.765625 17.480469 C 37.378906 17.980469 37.445312 18.683594 37.921875 19.09375 Z M 37.921875 19.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,63.921569%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 39.722656 20.292969 L 43.285156 20.292969 L 43.519531 20.496094 L 39.828125 20.496094 Z M 39.722656 20.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 46.417969 16.191406 C 46.207031 15.933594 45.886719 15.789062 45.550781 15.789062 L 21.605469 15.789062 C 21.273438 15.789062 20.953125 15.933594 20.738281 16.191406 C 20.117188 16.921875 20.644531 18.042969 21.605469 18.042969 L 45.550781 18.042969 C 46.511719 18.042969 47.035156 16.921875 46.417969 16.191406 Z M 46.417969 16.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,74.509804%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 46.722656 20.292969 L 20.441406 20.292969 C 19.476562 20.292969 18.957031 19.160156 19.585938 18.433594 C 19.800781 18.175781 20.113281 18.035156 20.441406 18.035156 L 46.71875 18.035156 C 47.046875 18.035156 47.359375 18.175781 47.574219 18.425781 C 48.207031 19.15625 47.683594 20.289062 46.71875 20.289062 Z M 46.722656 20.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.803922%,63.921569%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 45.550781 18.042969 C 45.550781 18.042969 39.578125 18.472656 33.578125 18.472656 C 27.289062 18.472656 21.601562 18.042969 21.601562 18.042969 Z M 45.550781 18.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,64.705882%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 41.878906 36.601562 L 82.734375 36.601562 L 82.734375 46.25 L 41.878906 46.25 Z M 41.878906 36.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.625 36.601562 L 68 36.601562 L 68 46.25 L 56.625 46.25 Z M 56.625 36.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 66.699219 36.601562 L 68 36.601562 L 68 46.25 L 66.699219 46.25 Z M 66.699219 36.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 56.625 36.601562 L 57.925781 36.601562 L 57.925781 46.25 L 56.625 46.25 Z M 56.625 36.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,64.705882%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 48.144531 46.253906 L 88.996094 46.253906 L 88.996094 55.898438 L 48.144531 55.898438 Z M 48.144531 46.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.886719 46.253906 L 74.261719 46.253906 L 74.261719 55.898438 L 62.886719 55.898438 Z M 62.886719 46.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 72.960938 46.253906 L 74.261719 46.253906 L 74.261719 55.898438 L 72.960938 55.898438 Z M 72.960938 46.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 62.886719 46.253906 L 64.1875 46.253906 L 64.1875 55.898438 L 62.886719 55.898438 Z M 62.886719 46.253906 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,64.705882%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 43.148438 55.898438 L 84 55.898438 L 84 65.542969 L 43.148438 65.542969 Z M 43.148438 55.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.894531 55.898438 L 69.269531 55.898438 L 69.269531 65.542969 L 57.894531 65.542969 Z M 57.894531 55.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 67.96875 55.898438 L 69.269531 55.898438 L 69.269531 65.542969 L 67.96875 65.542969 Z M 67.96875 55.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 57.894531 55.898438 L 59.195312 55.898438 L 59.195312 65.542969 L 57.894531 65.542969 Z M 57.894531 55.898438 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,64.705882%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 48.148438 65.542969 L 89 65.542969 L 89 75.1875 L 48.148438 75.1875 Z M 48.148438 65.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.886719 65.542969 L 74.261719 65.542969 L 74.261719 75.1875 L 62.886719 75.1875 Z M 62.886719 65.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 72.960938 65.542969 L 74.261719 65.542969 L 74.261719 75.1875 L 72.960938 75.1875 Z M 72.960938 65.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 62.886719 65.542969 L 64.1875 65.542969 L 64.1875 75.1875 L 62.886719 75.1875 Z M 62.886719 65.542969 "
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.54902%,64.705882%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 46.921875 75.1875 L 87.773438 75.1875 L 87.773438 84.832031 L 46.921875 84.832031 Z M 46.921875 75.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 61.660156 75.1875 L 73.035156 75.1875 L 73.035156 84.832031 L 61.660156 84.832031 Z M 61.660156 75.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 71.734375 75.1875 L 73.035156 75.1875 L 73.035156 84.832031 L 71.734375 84.832031 Z M 71.734375 75.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(95.294118%,97.647059%,63.529412%)",
      fillOpacity: 1
    },
    d: "M 61.660156 75.1875 L 62.960938 75.1875 L 62.960938 84.832031 L 61.660156 84.832031 Z M 61.660156 75.1875 "
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 29.6875 62.667969 L 48.539062 62.667969 L 48.539062 67.332031 L 29.6875 67.332031 Z M 29.6875 62.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 48.226562 62.167969 L 30.003906 62.167969 L 29.6875 62.667969 L 48.546875 62.667969 Z M 48.226562 62.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 30.003906 67.832031 L 48.226562 67.832031 L 48.546875 67.332031 L 29.6875 67.332031 Z M 30.003906 67.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 35.40625 62.667969 L 36.855469 62.667969 L 36.855469 67.332031 L 35.40625 67.332031 Z M 35.40625 62.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 37.210938 62.667969 L 37.738281 62.667969 L 37.738281 67.332031 L 37.210938 67.332031 Z M 37.210938 62.667969 "
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 29.6875 68.332031 L 48.539062 68.332031 L 48.539062 72.996094 L 29.6875 72.996094 Z M 29.6875 68.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 48.226562 67.832031 L 30.003906 67.832031 L 29.6875 68.332031 L 48.546875 68.332031 Z M 48.226562 67.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 30.003906 73.496094 L 48.226562 73.496094 L 48.546875 72.996094 L 29.6875 72.996094 Z M 30.003906 73.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 35.40625 68.332031 L 36.855469 68.332031 L 36.855469 72.996094 L 35.40625 72.996094 Z M 35.40625 68.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 37.210938 68.332031 L 37.738281 68.332031 L 37.738281 72.996094 L 37.210938 72.996094 Z M 37.210938 68.332031 "
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 29.6875 74 L 48.539062 74 L 48.539062 78.667969 L 29.6875 78.667969 Z M 29.6875 74 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 48.226562 73.496094 L 30.003906 73.496094 L 29.6875 74 L 48.546875 74 Z M 48.226562 73.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 30.003906 79.167969 L 48.226562 79.167969 L 48.546875 78.667969 L 29.6875 78.667969 Z M 30.003906 79.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 35.40625 74 L 36.855469 74 L 36.855469 78.667969 L 35.40625 78.667969 Z M 35.40625 74 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 37.210938 74 L 37.738281 74 L 37.738281 78.667969 L 37.210938 78.667969 Z M 37.210938 74 "
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 29.6875 79.667969 L 48.539062 79.667969 L 48.539062 84.332031 L 29.6875 84.332031 Z M 29.6875 79.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 48.226562 79.167969 L 30.003906 79.167969 L 29.6875 79.667969 L 48.546875 79.667969 Z M 48.226562 79.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 30.003906 84.832031 L 48.226562 84.832031 L 48.546875 84.332031 L 29.6875 84.332031 Z M 30.003906 84.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 35.40625 79.667969 L 36.855469 79.667969 L 36.855469 84.332031 L 35.40625 84.332031 Z M 35.40625 79.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 37.210938 79.667969 L 37.738281 79.667969 L 37.738281 84.332031 L 37.210938 84.332031 Z M 37.210938 79.667969 "
  }), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.613281 56.996094 L 35.46875 56.996094 L 35.46875 61.664062 L 16.613281 61.664062 Z M 16.613281 56.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 35.148438 56.496094 L 16.933594 56.496094 L 16.613281 56.996094 L 35.46875 56.996094 Z M 35.148438 56.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 16.933594 62.167969 L 35.148438 62.167969 L 35.46875 61.664062 L 16.613281 61.664062 Z M 16.933594 62.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 22.328125 56.996094 L 23.777344 56.996094 L 23.777344 61.664062 L 22.328125 61.664062 Z M 22.328125 56.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 24.132812 56.996094 L 24.660156 56.996094 L 24.660156 61.664062 L 24.132812 61.664062 Z M 24.132812 56.996094 "
  }), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.613281 62.667969 L 35.46875 62.667969 L 35.46875 67.332031 L 16.613281 67.332031 Z M 16.613281 62.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 35.148438 62.167969 L 16.933594 62.167969 L 16.613281 62.667969 L 35.46875 62.667969 Z M 35.148438 62.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 16.933594 67.832031 L 35.148438 67.832031 L 35.46875 67.332031 L 16.613281 67.332031 Z M 16.933594 67.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 22.328125 62.667969 L 23.777344 62.667969 L 23.777344 67.332031 L 22.328125 67.332031 Z M 22.328125 62.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 24.132812 62.667969 L 24.660156 62.667969 L 24.660156 67.332031 L 24.132812 67.332031 Z M 24.132812 62.667969 "
  }), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.613281 68.332031 L 35.46875 68.332031 L 35.46875 72.996094 L 16.613281 72.996094 Z M 16.613281 68.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 35.148438 67.832031 L 16.933594 67.832031 L 16.613281 68.332031 L 35.46875 68.332031 Z M 35.148438 67.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 16.933594 73.496094 L 35.148438 73.496094 L 35.46875 72.996094 L 16.613281 72.996094 Z M 16.933594 73.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 22.328125 68.332031 L 23.777344 68.332031 L 23.777344 72.996094 L 22.328125 72.996094 Z M 22.328125 68.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 24.132812 68.332031 L 24.660156 68.332031 L 24.660156 72.996094 L 24.132812 72.996094 Z M 24.132812 68.332031 "
  }), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.613281 74 L 35.46875 74 L 35.46875 78.667969 L 16.613281 78.667969 Z M 16.613281 74 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 35.148438 73.496094 L 16.933594 73.496094 L 16.613281 74 L 35.46875 74 Z M 35.148438 73.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 16.933594 79.167969 L 35.148438 79.167969 L 35.46875 78.667969 L 16.613281 78.667969 Z M 16.933594 79.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 22.328125 74 L 23.777344 74 L 23.777344 78.667969 L 22.328125 78.667969 Z M 22.328125 74 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 24.132812 74 L 24.660156 74 L 24.660156 78.667969 L 24.132812 78.667969 Z M 24.132812 74 "
  }), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.803922%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 16.613281 79.667969 L 35.46875 79.667969 L 35.46875 84.332031 L 16.613281 84.332031 Z M 16.613281 79.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,77.254902%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 35.148438 79.167969 L 16.933594 79.167969 L 16.613281 79.667969 L 35.46875 79.667969 Z M 35.148438 79.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,60.392157%,4.705882%)",
      fillOpacity: 1
    },
    d: "M 16.933594 84.832031 L 35.148438 84.832031 L 35.46875 84.332031 L 16.613281 84.332031 Z M 16.933594 84.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 22.328125 79.667969 L 23.777344 79.667969 L 23.777344 84.332031 L 22.328125 84.332031 Z M 22.328125 79.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,83.921569%,58.039216%)",
      fillOpacity: 1
    },
    d: "M 24.132812 79.667969 L 24.660156 79.667969 L 24.660156 84.332031 L 24.132812 84.332031 Z M 24.132812 79.667969 "
  }), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrutoIcon);
export default __webpack_public_path__ + "static/media/bruto_icon.727536983ba89aeb45fcf1e87047a792.svg";
export { ForwardRef as ReactComponent };